const sortOrderNone = `<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M9.99959 3.69702C10.1985 3.69702 10.3893 3.77604 10.5299 3.91669L13.8633 7.25002C14.1561 7.54292 14.1561 8.01779 13.8633 8.31069C13.5704 8.60358 13.0955 8.60358 12.8026 8.31069L9.99959 5.50768L7.19659 8.31069C6.9037 8.60358 6.42882 8.60358 6.13593 8.31069C5.84304 8.01779 5.84304 7.54292 6.13593 7.25002L9.46926 3.91669C9.60992 3.77604 9.80068 3.69702 9.99959 3.69702Z"
    fill="var(--fh-color-icon-disabled)"
  />
  <path
    d="M9.99894 16.303C9.80003 16.303 9.60926 16.224 9.46861 16.0833L6.13528 12.75C5.84239 12.4571 5.84239 11.9822 6.13528 11.6893C6.42817 11.3964 6.90305 11.3964 7.19594 11.6893L9.99894 14.4923L12.8019 11.6893C13.0948 11.3964 13.5697 11.3964 13.8626 11.6893C14.1555 11.9822 14.1555 12.4571 13.8626 12.75L10.5293 16.0833C10.3886 16.224 10.1979 16.303 9.99894 16.303Z"
    fill="var(--fh-color-icon-disabled)"
  />
</svg>
`;
export {
  sortOrderNone as default
};
//# sourceMappingURL=sortOrderNone.mjs.map
